// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Pie } from "react-chartjs-2";

// ChartJS.register(ArcElement, Tooltip, Legend);

import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { PolarArea } from "react-chartjs-2";

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export function SOVChart({ data }) {
  const options = {
    responsive: true,
    scales: {
      r: {
        ticks: {
          display: false,
        },
        pointLabels: {
          display: true,
          centerPointLabels: true,
          font: {
            size: 10,
          },
        },
      },
    },
    plugins: {
      tooltip: {
        displayColors: false,
        callbacks: {
          label: (context) => {
            const value = Number(context.raw);
            return `${context.dataset.label}: ${value}%`;
          },
        },
        boxPadding: 5,
        cornerRadius: 10,
        caretSize: 10,
        padding: 10,
        margin: 0,
        boxHeight: 30,
        borderWidth: 1,
        borderColor: "#00000033",
        boxWidth: 10,
        titleColor: "black",
        bodyColor: "black",
        bodyFont: {
          size: 14,
          weight: 500,
          font: "Lato",
        },
        bodySpacing: 7,
        usePointStyle: true,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleFont: {
          weight: 600,
          size: 14,
          font: "Lato",
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
  };
  const chartData = {
    labels:
      data?.models?.map((item) => {
        return item.name;
      }) || [],
    datasets: [
      {
        label: "SOV",
        data:
          data?.models?.map((item) => {
            return item.percent;
          }) || [],
        backgroundColor:
          data?.models?.map((item) => {
            return item.color;
          }) || [],
        borderColor: ["white"],
        borderWidth: 1,
      },
    ],
  };

  return <PolarArea data={chartData} options={options} />;
  // return <Pie data={chartData} options={options} />;
}
